import { render, staticRenderFns } from "./stock-market.vue?vue&type=template&id=a0bf0fc8"
import script from "./stock-market.vue?vue&type=script&lang=js"
export * from "./stock-market.vue?vue&type=script&lang=js"
import style0 from "./stock-market.vue?vue&type=style&index=0&id=a0bf0fc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports